<template>
  <v-card :disabled="disabled" color="surface lighten-1" elevation="3" class="dashboard-card" :class="{ expanded }">
    <v-btn class="expand-toggle" icon @click="expanded = !expanded">
      <v-icon v-if="expanded">mdi-arrow-collapse</v-icon>
      <v-icon v-else>mdi-arrow-expand</v-icon>
    </v-btn>
    <slot />
  </v-card>
</template>

<script>
export default {
  name: 'EcsDashboardCard',

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    expansible: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      expanded: false
    };
  },

  watch: {
    expanded() {
      this.$emit('resize', this.expanded);
    }
  }
};
</script>

<style src="./scoped.css" scoped></style>

<style>
.dashboard-card.v-card--disabled > *:not(.v-card__progress):not(.expand-toggle):not(.card-help-btn) {
  opacity: 1 !important;
}
</style>
